import React from 'react'
import {
    BackButton,
    Bloc,
    BlocIntField,
    BlocEligibilitePTZ,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue6() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Qui sont les emprunteurs ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <Conditionnal
                        linked_data_id="prj_maturite"
                        isEqualTo
                        targetDataValueCompare="TROUVE"
                    >
                        <BackButton />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_maturite"
                        isEqualTo
                        targetDataValueCompare="RECHERCHE"
                    >
                        <BackButton targetView={4} />
                    </Conditionnal>
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={25} time={3} />
            </div>
            <div className="Container">
                <Bloc
                    key="key42"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="1"
                    nbcolumn={2}
                    gauche
                    imageTextStyle
                    logourl="svg/one_person.svg"
                    text1="Vous empruntez"
                    text2="Seul"
                />
                <Bloc
                    key="key43"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="2"
                    nbcolumn={2}
                    droit
                    imageTextStyle
                    logourl="svg/two_person.svg"
                    text1="Vous empruntez"
                    text2="À deux"
                />
                <Bloc
                    key="key44"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="SCI"
                    nbcolumn={2}
                    gauche
                    imageTextStyle
                    logourl="svg/scpi.svg"
                    text1="Vous empruntez"
                    text2="en SCI"
                />
            </div>

            {/* 
						SI projet usage = locatif
							on continu
						Si projet usage n est pas locatif : On demande si a été proprio les 2 dernieres années
							Si a été proprio  ou pas en trouvé 
							  on continu
							Si n a pas été proprio  et  trouvé
								SI logement NEUF : on demande le revenu fiscal
								SI TERRAIN / construction : on demande le revenu fiscal 
								SINON on continu
					 */}
            <Conditionnal linked_data_id="emp_type_emprunteur" isNotEmpty>

                <div className="Container">
                    <Title maintitle="Combien de personnes font partie de votre foyer ?" />
                    <BlocIntField
                        key="key59"
                        nbcolumn={1}
                        linked_data_id="emp_nb_personnes_foyer"
                        label="Nombre de personnes de votre foyer ( y compris vous )"
                        placeholder="Ex : 4"
                        format="##"
                    />
                </div>
                <Conditionnal
                    linked_data_id="prj_usage"
                    isNotEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <Conditionnal
                        linked_data_id="prj_type"
                        isNotEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <div className="Container">
                            <Title
                                maintitle="Avez-vous été propriétaire de votre résidence principale ?"
                                secondarytitlebold="Au cours des 2 dernières années"
                            />
                            <Bloc
                                key="key45"
                                selectable
                                linked_data_id="emp_proprio_last_2_ans"
                                linked_data_value="OUI"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Oui"
                            />
                            <Bloc
                                key="key46"
                                selectable
                                linked_data_id="emp_proprio_last_2_ans"
                                linked_data_value="NON"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Non"
                            />
                        </div>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_type"
                        isEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <Conditionnal
                             linked_data_id="emp_nb_personnes_foyer"
                             isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                <Button text="Suivant" targetView={7} />
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emp_proprio_last_2_ans"
                        isEqualTo
                        targetDataValueCompare="NON"
                    >
                        <Conditionnal
                            linked_data_id="prj_type"
                            isEqualTo
                            targetDataValueCompare="LOGEMENT_NEUF"
                        >
                            <div className="Container">
                                <BlocIntField
                                    key="keydedegtgt56"
                                    linked_data_id="finance_revenu_fiscal_ref"
                                    symbole=" €"
                                    label="Revenu fiscal de référence de votre foyer"
                                    placeholder="Ex : 35 000 €"
                                />
                            </div>
                            <Conditionnal
                                linked_data_id="finance_revenu_fiscal_ref"
                                isNotEmpty
                            >
                                <Conditionnal
                                    linked_data_id="prj_maturite"
                                    isEqualTo
                                    targetDataValueCompare="TROUVE"
                                >
                                    <div className="Container">
                                        <BlocEligibilitePTZ />
                                    </div>
                                </Conditionnal>
                                <Conditionnal
                                     linked_data_id="emp_nb_personnes_foyer"
                                     isNotEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        <Button text="Suivant" targetView={7} />
                                    </div>
                                </Conditionnal>
                            </Conditionnal>
                            <Conditionnal
                                linked_data_id="prj_type_log"
                                isNotIn
                                targetDataValueCompare={["APPARTEMENT", "MAISON_COLLECTIVE"]}
                            >
                                <div className="SubmitButtonContainer">
                                    <Button text="Suivant" targetView={7} />
                                </div>
                            </Conditionnal>
                        </Conditionnal>


                        <Conditionnal
                            linked_data_id="prj_type"
                            isIn
                            targetDataValueCompare={["TERRAIN_ET_CONSTRUCTION", "LOGEMENT_ANCIEN"]}
                        >

                            <div className="Container">
                                <BlocIntField
                                    key="keydedegtgt56"
                                    linked_data_id="finance_revenu_fiscal_ref"
                                    symbole=" €"
                                    label="Revenu fiscal de référence de votre foyer"
                                    placeholder="Ex : 35 000 €"
                                />
                            </div>
                            <Conditionnal
                                linked_data_id="finance_revenu_fiscal_ref"
                                isNotEmpty
                            >
                                <Conditionnal
                                    linked_data_id="prj_maturite"
                                    isEqualTo
                                    targetDataValueCompare="TROUVE"
                                >
                                    <div className="Container">
                                        <BlocEligibilitePTZ />
                                    </div>
                                </Conditionnal>
                                <Conditionnal
                                     linked_data_id="emp_nb_personnes_foyer"
                                     isNotEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        <Button text="Suivant" targetView={7} />
                                    </div>
                                </Conditionnal>
                            </Conditionnal>
                        </Conditionnal>

                        <Conditionnal
                            linked_data_id="prj_type"
                            notIn
                            targetDataValueCompare={["LOGEMENT_NEUF", "TERRAIN_ET_CONSTRUCTION", "LOGEMENT_ANCIEN", "RENEGOCIATION"]}
                        >
                            <Conditionnal
                                 linked_data_id="emp_nb_personnes_foyer"
                                 isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    <Button text="Suivant" targetView={7} />
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>

                    <Conditionnal
                        linked_data_id="emp_proprio_last_2_ans"
                        isEqualTo
                        targetDataValueCompare="OUI"
                    >
                        <Conditionnal
                            linked_data_id="emp_nb_personnes_foyer"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                <Button text="Suivant" targetView={7} />
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_usage"
                    isEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <Conditionnal
                         linked_data_id="emp_nb_personnes_foyer"
                         isNotEmpty
                    >
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={7} />
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
